import axios from 'axios'
import axiosConfig from '../../../config/axios.config'
import { checkResponseErrorCodeAndRedirect } from '../../../utils/errorHelper'

const {apiUrl} = axiosConfig;

// -- fetch trial data
export const fetchTrial = async (nctId, instance, email) => {
  try {
    // removed 'axiosConfig.auth' as token is updated on login
    const data = await axios.get(`${apiUrl}/rt/getOverviewData/${nctId}/${instance}/${email}`)
    // console.log('fetchTrial', data)
    return data.data ? data.data : data;
  } catch(err) {
    console.error(err, 'Error occurred fetching trial data.')
    checkResponseErrorCodeAndRedirect(err)
  }
}

// fetch terms
export const fetchTerms = async (id, email, instance) => {
  try {
    return await axios.get(`${apiUrl}/rt/allTrials/${instance}/conditions/none/${email}?nct=${id}`)
  } catch (err) {
    console.error(err, 'Error occurred fetching terms.')
    checkResponseErrorCodeAndRedirect(err)
  }
}

// remove terms
export const removeTerms = async (id, term, instance, email, bulk) => {
  try {
    return await axios.post(`${apiUrl}/rt/removeTerms`, {id, email, instance, term, bulk})
  } catch (err) {
    console.error(err, 'Error occurred removing terms.')
    checkResponseErrorCodeAndRedirect(err)
  }
}


// -- send update to server
export const updateTrial = async (id, instance, email, userId, originalData, updatedData) => {
  try {
    let body = {
      custom: updatedData,
      original: originalData,
      userId
    }
    let url = `${apiUrl}/rt/saveEditedTrial/${id}/${instance}/${email}`
    if(updatedData.isMID) {
      body = {
        customDescription: updatedData.customDescription,
        customTitle: updatedData.customTitle,
        studyPopulation: updatedData.studyPopulation,
        whatsInvolved: updatedData.whatsInvolved,
        trialLast: updatedData.trialLast,
        userId
      };
      url = `${apiUrl}/rt/console/saveCustomManual/${id}/${email}`
    }
    // removed 'axiosConfig.auth' as token is updated on login
    return await axios.post(url, body);
  } catch(err) {
    console.error(err, 'Error occurred updating trial data.')
    checkResponseErrorCodeAndRedirect(err)
  }
}
